"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AnalyticsEventType;
(function (AnalyticsEventType) {
    AnalyticsEventType["FlowLoaded"] = "FlowLoaded";
    AnalyticsEventType["FlowClosed"] = "FlowClosed";
    AnalyticsEventType["UrlOpened"] = "UrlOpened";
    AnalyticsEventType["StepLoaded"] = "StepLoaded";
    AnalyticsEventType["StepCompleted"] = "StepCompleted";
    AnalyticsEventType["EmailCollected"] = "EmailCollected";
    AnalyticsEventType["FlowFinalized"] = "FlowFinalized";
    AnalyticsEventType["PhoneCollected"] = "PhoneCollected";
})(AnalyticsEventType || (AnalyticsEventType = {}));
exports.default = AnalyticsEventType;
